module.exports = "https://static.wanderu.com/ui-react/_next/static/media/time.9ebb58b9.png";